<template>
  <div class="fg-skeleton" role="status" :aria-label="label">
    <p
      v-if="label"
      class="fg-skeleton__label"
    >
      {{ label }}
    </p>
    <div
      v-for="i in count"
      :key="i"
      class="fg-skeleton__card"
    >
      <div class="fg-skeleton__bar fg-skeleton__bar--title" />
      <div class="fg-skeleton__bar fg-skeleton__bar--sub" />
      <div class="fg-skeleton__foot">
        <div class="fg-skeleton__bar fg-skeleton__bar--pill" />
        <div class="fg-skeleton__bar fg-skeleton__bar--price" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Cartes fantômes animées (shimmer) affichées sur Results pendant l'appel
// availability. Purement présentationnel — styles dans styles.css (.fg-skeleton*).
withDefaults(defineProps<{ label?: string; count?: number }>(), { count: 3 })
</script>
